import { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { myorderslist } from "../../Apiservices/Auth/Myorders/Myordersapi";
import { addServiceToCart } from "../../store/cartbodydataslice";
import { addToCart } from "../../store/cartSlice";

export default function useMyOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const populateCartFromOrders = (ordersData) => {
    (ordersData.upcoming || []).forEach((event) => {
      const eveId = event.event_id;
      const eventname = event.event_title;
      const event_start_date = event.event_start_date;

      // ============================================
      // 1. PRIEST
      // ============================================
      event.priestdata?.forEach((priestItem) => {
        const provider = priestItem.priest;
        const service = priestItem.service;

        // Add to cartbodySlice
        dispatch(
          addServiceToCart({
            eveId,
            eventname,
            event_start_date,
            type: "priestData",
            item: {
              ...priestItem,
              provider_id: provider.id,
              providername: provider.name,
              mobileNumber: provider.mobileNumber,
              price: priestItem.total_amount,
              discountPrice: priestItem.discountPrice,
              validUpto: priestItem.validUpto,
              service_id: service.id,
              cart_id: priestItem.id,
              is_checked_out: priestItem.is_checked_out,
              is_edit_allowed: priestItem.is_edit_allowed,
              paid_amount: priestItem.paid_amount,
              balance_to_be_paid: priestItem.balance_to_be_paid,
              is_cancel_in_progress: priestItem.is_cancel_in_progress,
              is_canceled: priestItem.is_canceled,
              refund_complete: priestItem.refund_complete,
              refund_in_pending: priestItem.refund_in_pending,
              refunded_amount: priestItem.refunded_amount,
            },
          })
        );

        // Add to new cartSlice
        dispatch(
          addToCart({
            serviceType: "preist",
            eventID: eveId,
            providerID: provider.id,
            service_id: service.id,
            price: priestItem.total_amount,
            discountprice: priestItem.discountPrice,
            discountvalidupto: priestItem.validUpto,
            is_checked_out: true,
            quantity: 1,
            cart_id: priestItem.id,
          })
        );
      });

      // ============================================
      // 2. TENT HOUSE
      // ============================================
      event.tentproviderdata?.forEach((tentItem) => {
        dispatch(
          addServiceToCart({
            eveId,
            eventname,
            event_start_date,
            type: "tentHouseData",
            item: {
              ...tentItem,
              provider_id: tentItem.provider_id,
              providername: `${tentItem.first_name} ${tentItem.last_name}`,
              balance_to_be_paid: tentItem.balance_to_be_paid,
              is_checked_out: tentItem.is_checked_out,
              is_edit_allowed: tentItem.is_edit_allowed,
              paid_amount: tentItem.paid_amount,
              services: tentItem.items.map((item) => ({
                ...item,
                cart_id: item.tent_cart_item_id,
                mapping_id: item.mapping_id,
                service_id: item.service_id,
                quantity: item.quantity,
                price: item.price,
                discountPrice: item.discount_price,
                validUpto: item.discount_valid_upto,
              })),
              is_cancel_in_progress: tentItem.is_cancel_in_progress,
              is_canceled: tentItem.is_canceled,
              refund_complete: tentItem.refund_complete,
              refund_in_pending: tentItem.refund_in_pending,
              refunded_amount: tentItem.refunded_amount,
            },
          })
        );

        // Add to new cartSlice (one provider per event)
        dispatch(
          addToCart({
            serviceType: "tenthouse",
            eventID: eveId,
            providerID: tentItem.provider_id,
            service_id: null,
            price: null,
            discountprice: null,
            discountvalidupto: null,
            quantity: null,
            cart_id: null,
            is_checked_out: true,
          })
        );
      });

      // ============================================
      // 3. CATERING
      // ============================================
      event.cateringproviderdata?.forEach((cateringItem) => {
        dispatch(
          addServiceToCart({
            eveId,
            eventname,
            event_start_date,
            type: "cateringData",
            item: {
              ...cateringItem,
              provider_id: cateringItem.provider_id,
              providername: `${cateringItem.first_name} ${cateringItem.last_name}`,
              balance_to_be_paid: cateringItem.balance_to_be_paid,
              is_checked_out: cateringItem.is_checked_out,
              is_edit_allowed: cateringItem.is_edit_allowed,
              paid_amount: cateringItem.paid_amount,
              services: cateringItem.items.map((item) => ({
                ...item,
                mapping_id: item.item_id,
                service_id: item.category_id,
                quantity: item.number_of_people,
                price: item.regular_price,
                discountPrice: item.discounted_price,
                validUpto: item.valid_until,
                category: item.category.category_name,
                mealtype: item.meal.meal_name,
                cuisine: item.type.type_name,
              })),
              is_cancel_in_progress: cateringItem.is_cancel_in_progress,
              is_canceled: cateringItem.is_canceled,
              refund_complete: cateringItem.refund_complete,
              refund_in_pending: cateringItem.refund_in_pending,
              refunded_amount: cateringItem.refunded_amount,
            },
          })
        );

        // Add to new cartSlice (array for catering)
        cateringItem.items.forEach((item) => {
          dispatch(
            addToCart({
              serviceType: "catering",
              eventID: eveId,
              providerID: cateringItem.provider_id,
              service_id: item.category_id,
              mapping_id: item.item_id,
              price: item.regular_price,
              discountprice: item.discounted_price,
              discountvalidupto: item.valid_until,
              quantity: item.number_of_people,
              cart_id: null,
              is_checked_out: true,
            })
          );
        });
      });

      // ============================================
      // 4. VENUE
      // ============================================
      event.venuedata?.forEach((venueItem) => {
        // Transform food selections
        const foodSelections = venueItem.foodSelections?.map(food => ({
          id: food.id,
          menuId: food.menuId,
          guestCount: food.guestCount,
          pricePerPerson: food.pricePerPerson,
          subtotal: food.subtotal,
          menu: food.menu || { name: `Menu ${food.menuId}` },
        })) || [];

        // Transform drink selections
        const drinkSelections = venueItem.drinkSelections?.map(drink => ({
          id: drink.id,
          drinkOptionId: drink.drinkOptionId,
          guestCount: drink.guestCount,
          pricePerPerson: drink.pricePerPerson,
          subtotal: drink.subtotal,
          drinkOption: drink.drinkOption || { name: `Drink ${drink.drinkOptionId}` },
        })) || [];

        // Add to cartbodySlice
        dispatch(
          addServiceToCart({
            eveId,
            eventname,
            event_start_date,
            type: "venueData",
            item: {
              ...venueItem,
              id: venueItem.id,
              cartId: venueItem.cartId || venueItem.id,
              venueId: venueItem.venueId,
              spaceId: venueItem.spaceId,
              provider_id: venueItem.providerId || venueItem.provider_id,
              provider_name: venueItem.provider?.name || '',
              provider_mobile: venueItem.provider?.mobileNumber || '',
              provider_email: venueItem.provider?.emailId || '',
              venue_name: venueItem.venue?.name || '',
              venue_address: venueItem.venue?.address || '',
              venue_description: venueItem.venue?.description || '',
              section_name: venueItem.section?.name || '',
              section_capacity: venueItem.section?.capacity || '',
              pricing_type: venueItem.pricingType || venueItem.pricing_type,
              food_included: venueItem.foodIncluded || venueItem.food_included,
              outside_food_allowed: venueItem.outsideFoodAllowed || venueItem.outside_food_allowed,
              no_of_guests: venueItem.noOfGuests || venueItem.no_of_guests,
              from_date: venueItem.fromDate || venueItem.from_date,
              from_time: venueItem.fromTime || venueItem.from_time,
              to_date: venueItem.toDate || venueItem.to_date,
              to_time: venueItem.toTime || venueItem.to_time,
              rules_accepted: venueItem.rulesAccepted || venueItem.rules_accepted,
              base_price: venueItem.basePrice || venueItem.base_price,
              food_total: venueItem.foodTotal || venueItem.food_total,
              drink_total: venueItem.drinkTotal || venueItem.drink_total,
              subtotal: venueItem.subtotal,
              gst_percentage: venueItem.gstPercentage || venueItem.gst_percentage || 18,
              gst_amount: venueItem.gstAmount || venueItem.gst_amount || 0,
              total_amount: venueItem.totalAmount || venueItem.total_amount || 0,
              paid_amount: venueItem.paidAmount || venueItem.paid_amount || 0,
              balance_to_be_paid: venueItem.balanceToBePaid || venueItem.balance_to_be_paid || 0,
              is_checked_out: venueItem.isCheckedOut || venueItem.is_checked_out || true,
              is_edit_allowed: venueItem.isEditAllowed || venueItem.is_edit_allowed || false,
              is_canceled: venueItem.isCanceled || venueItem.is_canceled || false,
              is_pay_later: venueItem.isPayLater || venueItem.is_pay_later || false,
              refunded_amount: venueItem.refundedAmount || venueItem.refunded_amount || 0,
              booking_date: venueItem.booking_date,
              start_time: venueItem.start_time || venueItem.fromTime,
              end_time: venueItem.end_time || venueItem.toTime,
              guest_count: venueItem.guest_count || venueItem.noOfGuests,
              foodSelections: foodSelections,
              drinkSelections: drinkSelections,
              pricing: venueItem.pricing || {
                price: venueItem.subtotal || 0,
                discount_price: venueItem.subtotal || 0,
                gst_percentage: venueItem.gstPercentage || 18,
                gst_amount: venueItem.gstAmount || 0,
                total_amount: venueItem.totalAmount || 0,
              },
              paymentSummary: venueItem.paymentSummary || {
                totalAmount: venueItem.totalAmount || 0,
                paid: venueItem.paidAmount || 0,
                balance: venueItem.balanceToBePaid || 0,
                payable_now: venueItem.balanceToBePaid || 0,
              },
              venue: venueItem.venue || {},
              section: venueItem.section || {},
              provider: venueItem.provider || {},
              total: venueItem.totalAmount || venueItem.total_amount || 0,
              is_cancel_in_progress: venueItem.is_cancel_in_progress,
              is_canceled: venueItem.is_canceled,
              refund_complete: venueItem.refund_complete,
              refund_in_pending: venueItem.refund_in_pending,
              refunded_amount: venueItem.refunded_amount,
            },
          })
        );

        // Add to new cartSlice (venue - single provider per event)
        dispatch(
          addToCart({
            serviceType: "venue",
            eventID: eveId,
            providerID: venueItem.providerId || venueItem.provider_id,
            spaceId: venueItem.spaceId,
            guestCount: venueItem.noOfGuests || venueItem.guest_count,
            bookingDate: venueItem.fromDate || venueItem.from_date,
            bookingTime: venueItem.fromTime || venueItem.from_time,
            price: venueItem.subtotal || 0,
            discountprice: venueItem.totalAmount || 0,
            is_checked_out: true,
            cart_id: venueItem.cartId || venueItem.id,
            venueDetails: {
              name: venueItem.venue?.name || '',
              address: venueItem.venue?.address || '',
              sectionName: venueItem.section?.name || '',
              pricingType: venueItem.pricingType || venueItem.pricing_type,
            },
          })
        );
      });
    });
  };

  const fetchMyOrdersList = useCallback(async () => {
    setLoading(true);
    try {
      const response = await myorderslist();
      const data = response?.data || {};
      
      setOrders(data);
      populateCartFromOrders(data);
    } catch (err) {
      console.error("Couldn't get the list of my orders", err);
      setError("Failed to fetch orders. Please try again later.");
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  useEffect(() => {
    fetchMyOrdersList();
  }, [fetchMyOrdersList]);

  const refreshMyOrders = () => fetchMyOrdersList();

  return { orders, loading, error, refreshMyOrders };
}